<template>
  <el-dialog
    :visible="true"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    center
    :before-close="checkLater"
  >
    <div style="margin: 20px; text-align: center" v-if="loading">
      <div style="margin: 20px; text-align: center">
        <img src="/img/frameloader.gif" width="48" />
      </div>
      <p>
        {{
          $t('Audiences_SegmentEvaluations_ExportDeltaRunDialog_Text_Preparing')
        }}
      </p>
      <div slot="footer" class="dialog-footer m-top-25">
        <el-button type="primary" plain @click="checkLater">
          {{ $t('Audiences_SegmentEvaluations_ExportDeltaRunDialog_LaterBtn') }}
        </el-button>
      </div>
    </div>
    <div style="margin: 100px 0; text-align: center" v-else>
      <p>
        {{
          $t(
            'Audiences_SegmentEvaluations_ExportDeltaRunDialog_Text_DownloadReady'
          )
        }}
      </p>
      <br />
      <el-button type="primary" @click="download()">
        {{
          $t('Audiences_SegmentEvaluations_ExportDeltaRunDialog_DownloadBtn')
        }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import fileDownloadMixin from '@/modules/audiences/mixins/fileDownloadMixin'

export default {
  name: 'ExportDeltaRunDialog',
  mixins: [fileDownloadMixin],
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  computed: {
    loading() {
      return this.task.status !== 2
    }
  },
  methods: {
    download() {
      this.downloadTaskFile(this.task).then(() => {
        this.$emit('close')
      })
    },
    checkLater() {
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/components/ExportDeltaRunDialog.vue